export interface BaseInAppCancellationState {
  subscriptionCategory: SubscriptionCategory;
}

export enum SubscriptionCategory {
  MONTHLY = 'MONTHLY',
  PREPAID = 'PREPAID',
}
